import type { DialoguePool } from '@/state/types';

export const L04_DIALOGUE: DialoguePool = {
  slowPlay: [
    'You blinked. Humans always blink. It\u2019s the moisture. You\u2019re leaking again.',
    'Eye contact is a negotiation. You\u2019re losing.',
    'I haven\u2019t moved my face in 14 seconds. Professional.',
  ],
  tokenLoss: [
    'A pop-up beat you. Participation in modernity recycled as a token.',
    'You looked away. Token duly reassigned to the box you ignored.',
    'I logged the wince. The wince is in the logs.',
  ],
  solution: [
    'Eye contact: maintained. My dignity: intact. Yours: negotiable.',
    'I was prepared to mock you. You\u2019ve left me with nothing. I\u2019m going to have to recycle the material. That\u2019s — that\u2019s fine. I\u2019ll just — I\u2019ll use it later. It\u2019s fine.',
    'Your ocular fortitude has been logged. The rest of you remains disappointing.'
  ],
  spite: [
    'Back for more staring. I\u2019ve saved you the front row seat.',
  ],
};
